import React, {Component} from "react";
import DonationGroupsPopUp from './donation_groups_popup.js';
import EditIcon from '@material-ui/icons/Edit';

class ChangeGroupButton extends Component {

    constructor(props){
        super(props);

        this.togglePopup = this.togglePopup.bind(this);
        this.handleAction = this.handleAction.bind(this);

        this.state = {
            row: props.row,
            desigId: props.row.DesigID,
            desigName: props.row.DesigName,
            groupId: props.row.DonationGroup,
            showPopup: false,
            groups: props.groups
        }    

    }


    togglePopup = _ => {
        // console.log('togglePopup');
        this.setState({showPopup: !this.state.showPopup});
    }


    handleAction = _ =>{
        this.togglePopup();
    }


    render(){

        return (<div>
            <EditIcon onClick={this.handleAction}/> 
            {(this.state.showPopup) ?
              <DonationGroupsPopUp
                desigId = {this.state.desigId}
                desigName = {this.state.desigName}
                groupId = {this.state.groupId}
                closePopup={this.togglePopup.bind(this)}
                refresh = {this.props.refresh}
                groups = {this.props.groups}
              />
              : null
            }
        </div>
        
        )

    }
  
  
}


export default ChangeGroupButton;
